import { defineComponent as _defineComponent } from 'vue'
import CaretRightIcon from '@/assets/images/svg/caret-right.svg?component';
import type { TVulnerabilityDetails } from '@/_core/entities/vulnerability/models/types';
import type { TAppVersionReport, TSingleScanReport } from '@/_core/entities/report/models/types';
import { REPORT_ROUTE_NAMES } from '@/_core/entities/report/models/consts';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilityBreadcrumbs',
  props: {
    vulnerabilityData: null,
    reportData: null,
    jobId: null,
    integrationId: null,
    branchName: null,
    versionId: null
  },
  setup(__props: any) {

const props = __props as {
  vulnerabilityData: TVulnerabilityDetails;
  reportData: TAppVersionReport | TSingleScanReport;
  jobId?: string;
  integrationId?: string;
  branchName?: string;
  versionId?: string;
};



const isSingleScan = computed(() => !!props.jobId);

const topLabel = computed(() => {
  if (!isSingleScan.value) {
    return (props.reportData as TAppVersionReport).integrationName || props.reportData.fileName;
  }

  return props.reportData.fileName;
});

const topLink = computed(() => {
  if (!isSingleScan.value) {
    return {
      name: REPORT_ROUTE_NAMES.integrationBranch,
      params: { id: props.integrationId, branchName: props.branchName },
    };
  }

  return {
    name: REPORT_ROUTE_NAMES.singleScanReport,
    params: { jobId: props.jobId },
  };
});

const versionLink = computed(() => ({
  name: REPORT_ROUTE_NAMES.versionReport,
  params: {
    integrationId: props.integrationId,
    branchName: props.branchName,
    versionId: props.versionId,
  },
}));

return { __sfc: true,props, isSingleScan, topLabel, topLink, versionLink, CaretRightIcon }
}

})